<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
      label-width="68px"
      class="demo-form-inline"
    >
      <div>
        <el-form-item label="商铺编号" prop="shopNumber">
          <el-input
            v-model="queryParams.shopNumber"
            placeholder="请输入商铺编号"
            clearable
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>

        <el-form-item label="商铺名称" prop="shopName">
          <el-input
            v-model="queryParams.shopName"
            placeholder="请输入商铺名称"
            clearable
            @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="日期" prop="bdDate">
          <el-date-picker
            v-model="queryParams.bdDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
            >重置</el-button
          >
        </el-form-item>
      </div>
    </el-form>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" plain icon="el-icon-plus" size="mini" @click="handleAdd"
          >新增</el-button
        >
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          >导出</el-button
        >
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="designList">
      <el-table-column label="商铺编号" align="center" prop="shopNumber" />
      <el-table-column label="商铺名称" align="center" prop="shopName" />
      <el-table-column label="面积" align="center" prop="shopArea" />
      <el-table-column label="营运部" align="center" prop="verifier" />
      <el-table-column label="规划与工程部" align="center" prop="auditPerson" />
      <el-table-column label="物业管理处" align="center" prop="checkPerson" />
      <el-table-column label="部门负责人" align="center" prop="departmentHead" />
      <el-table-column label="客户意见" align="center" prop="customerFeedback" />
      <el-table-column
        label="商管公司总经理室意见"
        align="center"
        prop="companyFeedback"
      />
      <el-table-column label="物业公司总经理室意见" align="center" prop="realEstate" />
      <el-table-column label="甲方意见" align="center" prop="firstParty" />
      <!-- <el-table-column label="装修图片" align="center" prop="showPath">
        <template slot-scope="{ row }">
          <el-image
            v-if="row.showPath"
            style="width: 50px; height: 50px"
            :src="row.showPath"
            :preview-src-list="[row.showPath]"
          >
          </el-image>
        </template>
      </el-table-column> -->
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-view"
            @click="handleView(scope.row.id)"
            >打印预览</el-button
          >
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row.id)"
            >修改</el-button
          >
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-show="total > 0"
      :page-sizes="[10, 20, 30, 50]"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      ::page-size="queryParams.pageSize"
      @pagination="getList"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />

    <!-- 添加或修改ITC MALL商铺设计终审意见对话框 -->
    <CustomerTable ref="customerRef" :isPrint="isPrint" @getList="getList" />
    
  </div>
</template>

<script>
import CustomerTable from "./components/customerTable";
export default {
  name: "Design",
  components: { CustomerTable },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // ITC MALL商铺设计终审意见表格数据
      designList: [],
      
      
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        shopName: "",
        shopNumber: "",
        bdDate: null,
        startDate: undefined,
        endDate: undefined,
      },
      
      isPrint: false,
      // 表单参数
      form: {},
      // 表单校验
      rules: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询ITC MALL商铺设计终审意见列表 */
    getList() {
      this.loading = true;
      let startDate = "";
      let endDate = "";
      if (this.queryParams.bdDate && this.queryParams.bdDate.length > 1) {
        startDate = this.queryParams.bdDate[0];
        endDate = this.queryParams.bdDate[1];
      }
      this.$http
        .get(
          `/api/safe/design/list?pageNum=${this.queryParams.pageNum}&pageSize=${this.queryParams.pageSize}&startDate=${startDate}&endDate=${endDate}&shopName=${this.queryParams.shopName}&shopNumber=${this.queryParams.shopNumber}`
        )
        .then((res) => {
          // console.log(res, '店铺')
          this.designList = res.data.rows;
          this.total = res.data.total;
          this.loading = false;
        });
      // listDesign(this.queryParams).then(response => {

      // });
    },
    
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.$refs.queryForm.resetFields();
      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    /** 新增按钮操作 */
    handleAdd() {
      // this.id = "";
      // this.isPrint = false;
      // this.openDesignDialog = true;
      // this.$nextTick(() => {
      //   this.reset()
      // });
      // this.title = "新增";
      this.$refs.customerRef.handleAdd()
    },
    // 查看
    handleView(id) {
      this.$refs.customerRef.handleView(id)
      // console.log(id, "22");
      // this.isPrint = true;
      // this.$http.get(`/api/safe/design/${id}`).then((res) => {
      //   this.$refs.customerRef.info = res.data.data;
      //       const list = res.data.data.showPathUrl
      //       // console.log(list);
      //       this.$refs.customerRef.imgFileList = list.map(res => {
      //         return {
      //           url: res
      //         }
      //       })
      //   this.openDesignDialog = true;
      //   this.title = "查看";
      // });
    },
    /** 修改按钮操作 */
    handleUpdate(id) {
      this.$refs.customerRef.handleUpdate(id)
      // console.log(id, "22");
      // this.isPrint = false;
      // this.id = id;
      // this.$http.get(`/api/safe/design/${id}`).then((res) => {
      //   this.openDesignDialog = true;
      //   this.title = "修改";
      //   this.$nextTick(() => {
      //     this.$refs.customerRef.info = res.data.data;
      //       const list = res.data.data.showPathUrl
      //       // console.log(list);
      //       this.$refs.customerRef.imgFileList = list.map(res => {
      //         return {
      //           url: res
      //         }
      //       })
      //   })
      // });
    },
    handleDelete(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http.delete("/api/safe/design/" + id).then((response) => {
          this.$message.success("删除成功");
          this.getList();
        });
      });
    },
   
    /** 导出按钮操作 */
    handleExport() {
      let startDate = "";
      let endDate = "";
      if (this.queryParams.bdDate && this.queryParams.bdDate.length > 1) {
        startDate = this.queryParams.bdDate[0];
        endDate = this.queryParams.bdDate[1];
      }
      const info = {
        shopName: this.queryParams.shopName,
        shopNumber: this.queryParams.shopNumber,
        startDate: startDate,
        endDate: endDate,
      }
      this.$http.post(`/api/safe/design/export`, {
					...info
				}, {
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json;charset=utf-8",
					},
					responseType: "blob"
				}).then(res => {
					const link = document.createElement("a");
					let blob = new Blob([res.data], {
						type: "application/vnd.ms-excel"
					});
					link.style.display = "none";
					link.href = URL.createObjectURL(blob);
					link.download = "店铺装修.xls";
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				})
    },
  },
};
</script>
<style lang="scss" scoped>
.app-container {
  padding: 20px 0;
}
</style>
